import { api } from './api'

export interface User {
  _id: string
  username: string
  email: string
  role: 'advertiser' | 'influencer'
  profileImage?: string
  bio?: string
  isVerified: boolean
}

export interface Message {
  _id: string
  conversation: string
  sender: string
  content: string
  createdAt: string
  updatedAt: string
  readAt?: string
}

// Backend response format for conversations
export interface BackendConversation {
  id: string
  campaignId?: string
  participant: {
    id: string
    name: string
    avatar: string
    type: 'influencer' | 'advertiser'
  }
  lastMessage?: string
  timestamp: string
  unreadCount: number
}

// Frontend conversation format
export interface Conversation {
  _id: string
  advertiser: string
  influencer: string
  campaign?: string
  participant: {
    _id: string
    username: string
    profileImage?: string
    role: 'influencer' | 'advertiser'
    email?: string
    isVerified?: boolean
  }
  lastMessage?: string
  createdAt: string
  updatedAt: string
}

export interface CreateConversationResponse {
  conversationId: string
}

export interface GetConversationsResponse {
  status: string;
  data: BackendConversation[];  // The data is directly an array of conversations
}

class MessagesService {
  async getConversations(): Promise<GetConversationsResponse> {
    const response = await api.get<GetConversationsResponse>('/api/messages/conversations');
    return response.data;
  }

  async getMessages(conversationId: string): Promise<Message[]> {
    const response = await api.get(`/api/messages/conversations/${conversationId}`)
    return response.data.data
  }

  async sendMessage(conversationId: string, content: string): Promise<Message> {
    const response = await api.post(`/api/messages/conversations/${conversationId}/messages`, { content })
    return response.data.data
  }

  async createConversation(influencerId: string, campaignId?: string): Promise<CreateConversationResponse> {
    const response = await api.post('/api/messages/conversations', { influencerId, campaignId })
    return response.data.data
  }

  async getUnreadCount(): Promise<{ count: number }> {
    const response = await api.get('/api/messages/unread-count')
    return response.data.data
  }
}

export const messagesService = new MessagesService() 